//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { type TooltipProps } from '../../..';
// import { type Currency } from '../../../utilities/types';
import { toggleStatisticsTotal, toggleStatisticsDetail } from './reducer';
import { showTooltip } from '../reducer';
import IconWithText from '../../../components/IconWithText';
import { formatCurrency } from '../../../utilities/numberFormatting';
import { CustomIconWithText } from '../../../components/Statistics/StatisticsStyles';
import Statistics from '../../../components/Statistics';
// import { getPartnerCurrency } from '../../../utilities/selectors';

export type ProcessingSums = Array<{
  transaction_amount: number,
  transaction_fee: number,
  revenue_share: number,
  currency: string
}>;
type Props = {
  processingSums: ProcessingSums,
  totalFeesUsd: string,
  // partnerCurrency: Currency,
  totalMerchants: number,
  totalReferralDetails: number,
  totalProcessingVolUsd: string,
  toggleStatisticsTotal: () => void,
  toggleStatisticsDetail: () => void,
  totalToggled: string,
  detailToggled: boolean,
  ...$Exact<TooltipProps>
};

class TableStatistics extends Component<Props> {
  processingVol = () => (
    <IconWithText
      message={
        'This is an estimated amount in USD based on the exchange rate at the time of purchase.'
      }
      label={formatCurrency(
        Number(this.props.totalProcessingVolUsd),
        this.props.currencies['USD']
      )}
      activeTooltip={this.props.activeTooltip}
      tooltipName={'PROCESSING_VOLUME_TOOLTIP'}
      showTooltip={this.props.showTooltip}
      smallIcon
    />
  );

  totalMerchants = (label: string) => (
    <CustomIconWithText
      message={
        'These are the total merchants referred by your partners. The number does not include direct merchant referrals'
      }
      label={label}
      activeTooltip={this.props.activeTooltip || ''}
      tooltipName={'TOTAL_MERCHANTS_TOOLTIP'}
      showTooltip={this.props.showTooltip || null}
      smallIcon
    />
  );

  totalFees = () => (
    <IconWithText
      message={
        'This is an estimated amount in USD based on the exchange rate at the time of purchase.'
      }
      label={formatCurrency(
        Number(this.props.totalFeesUsd),
        this.props.currencies['USD']
      )}
      activeTooltip={this.props.activeTooltip}
      tooltipName={'TRANSACTION_FEES_TOOLTIP'}
      showTooltip={this.props.showTooltip}
      smallIcon
    />
  );

  render() {
    return (
      <Statistics
        storageDetailOptions={{
          handler: this.props.toggleStatisticsDetail,
          slice: this.props.detailToggled,
          value: 'statisticsDetailToggled'
        }}
        storageTotalOptions={{
          handler: this.props.toggleStatisticsTotal,
          slice: this.props.totalToggled,
          value: 'statisticsTotalToggled'
        }}
        tableHeaderOptions={{
          desktop: [
            {
              lg: 'Total Partners',
              sm: '# Partners',
              smCustomWidth: '85px',
              lgCustomWidth: '113px'
            },
            {
              lg: this.totalMerchants('Total Merchants'),
              sm: this.totalMerchants('# Merchants'),
              right: true
            },
            {
              lg: 'Total Processing Vol.',
              sm: 'Tot. Processing Vol.',
              right: true
            },
            { lg: 'Total Trans. Fees', sm: 'Tot Trans. Fees', right: true },
            { lg: 'Total Comm. Earned', sm: 'Tot Comm. Earned', right: true }
          ],
          device: {
            row1: [
              { lg: 'Total Partners', sm: 'Tot. Partners' },
              {
                lg: this.totalMerchants('Total Merchants'),
                sm: this.totalMerchants('Tot. Merchants'),
                tooltip: true,
                right: true
              }
            ],
            row2: [
              { lg: 'Total Processing Vol.', sm: 'Tot. Processing Vol.' },
              { lg: 'Tot. Fees', right: true },
              { lg: 'Total Comm. Earned', sm: 'Tot. Comm. Earned', right: true }
            ]
          }
        }}
        tableRowOptions={{
          desktop: {
            breakdown: {
              data: this.props.processingSums,
              columns: [
                {
                  value: this.props.totalReferralDetails,
                  showOnce: true,
                  right: true,
                  bold: true,
                  customPadding: '10px'
                },
                {
                  value: this.props.totalMerchants,
                  showOnce: true,
                  right: true,
                  bold: true
                },
                { value: 'transaction_amount', right: true },
                { value: 'transaction_fee', right: true },
                { value: 'revenue_share', right: true }
              ]
            },
            total: {
              toggled: [
                { value: 'TOTAL USD', bold: true },
                { value: '', right: true },
                { value: this.processingVol(), right: true, bold: true },
                { value: this.totalFees(), right: true, bold: true },
                { value: 'toggle', right: true, bold: true }
              ],
              untoggled: [
                {
                  value: this.props.totalReferralDetails,
                  right: true,
                  bold: true,
                  customPadding: '10px'
                },
                { value: this.props.totalMerchants, right: true, bold: true },
                { value: this.processingVol(), right: true },
                { value: this.totalFees(), right: true },
                { value: 'toggle', right: true }
              ]
            }
          },
          device: {
            row1: [
              { value: this.props.totalReferralDetails, bold: true },
              { value: this.props.totalMerchants, right: true, bold: true }
            ],
            row2: {
              breakdown: {
                data: this.props.processingSums,
                columns: [
                  { value: 'transaction_amount' },
                  { value: 'transaction_fee' },
                  { value: 'revenue_share' }
                ]
              },
              total: [
                { value: this.processingVol() },
                { value: this.totalFees() },
                { value: 'toggle' }
              ]
            }
          }
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  processingSums: state.partners.statistics.processing_sums,
  totalFeesUsd: state.partners.statistics.total_fees_usd,
  totalMerchants: state.partners.statistics.total_merchants,
  totalProcessingVolUsd: state.partners.statistics.total_processing_vol_usd,
  totalReferralDetails: state.partners.statistics.total_referral_details,
  totalToggled: state.partners.statistics.totalToggled,
  detailToggled: state.partners.statistics.detailToggled,
  activeTooltip: state.partners.index.activeTooltip,
  currencies: state.global.currencies
  // TODO: In the future, if USD is not used as the main currency for estimating totals, make this variable dynamic.
  // partnerCurrency: getPartnerCurrency(state),
});

const mapDispatchToProps = {
  toggleStatisticsTotal,
  toggleStatisticsDetail,
  showTooltip
};

export default connect(mapStateToProps, mapDispatchToProps)(TableStatistics);
